import React from 'react';

export default function GoogleSiteVerificationPage() {
  return <>{'google-site-verification: googlee6d04b2c36165ca6.html'}</>;
}
